module.exports = __webpack_public_path__ + "img/designYourNeeds.03139b94.webp";